export const isNumeric = n => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

export const numberToCurrency = (
    num,
    { wrapNegativesInParentheses = false, decimals = 2 } = {},
) => {
    if (!num || !isNumeric(num)) {
        num = 0;
    }

    if (wrapNegativesInParentheses) {
        if (num < 0) {
            num = Math.abs(num);
        } else {
            wrapNegativesInParentheses = false;
        }
    }

    num = Number(num).toFixed(decimals);

    if (num.split('.')[0].length > 3) {
        num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    if (wrapNegativesInParentheses) {
        num = `(${num})`;
    }

    return `<span class="currency-view">
                <span class="symbol">$</span>
                <span class="amount">${num}</span>
            </span>`;
};

export const currencyToNumber = num => {
    if (num) {
        return Number(String(num).replace(/[^0-9-.]/g, ''));
    } else {
        return 0;
    }
};

export const formatCurrency = number =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(number);
